import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { SparkProvider } from "@/lib/store";
import Layout from "@/components/Layout";
import Welcome from "@/pages/Welcome";
import Dashboard from "@/pages/Dashboard";
import Onboarding from "@/pages/Onboarding";
import StartingPoint from "@/pages/StartingPoint";
import PartOne from "@/pages/PartOne";
import Activity from "@/pages/Activity";
import CareerCompass from "@/pages/CareerCompass";
import PartTwo from "@/pages/PartTwo";
import CareerPulse from "@/pages/CareerPulse";
import EvidenceMap from "@/pages/EvidenceMap";
import SignIn from "@/pages/SignIn";
import Start from "@/pages/Start";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ResetPassword from "@/pages/ResetPassword";
import AuthConsume from "@/pages/AuthConsume";
import Admin from "@/pages/Admin";
import PilotWelcome from "@/pages/PilotWelcome";
import Conversation from "@/pages/Conversation";
import { SparkErrorBoundary } from "@/components/SparkErrorBoundary";

const friendly = (err) => {
  const status = err?.response?.status;
  if (status === 401) return "Your session has ended. Please sign in again.";
  if (status === 403) return "That isn't yours to open.";
  if (status === 404 || status === 502 || status === 503 || !status) return "Spark lost the connection for a moment. Please try that again.";
  return err?.response?.data?.detail || "Something interrupted us. Please try again.";
};
window.addEventListener("unhandledrejection", (ev) => {
  if (ev.reason?.isAxiosError) {
    ev.preventDefault();
    toast(friendly(ev.reason));
  }
});

function App() {
  return (
    <SparkErrorBoundary><SparkProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors={false} theme="light" />
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/start" element={<Start />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/consume" element={<AuthConsume />} />
          <Route path="/admin" element={<Admin />} />
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/starting-point" element={<StartingPoint />} />
            <Route path="/part-one" element={<PartOne />} />
            <Route path="/welcome-note" element={<PilotWelcome />} />
            <Route path="/conversation/why-am-i-here" element={<Conversation />} />
            <Route path="/part-one/career-pulse" element={<CareerPulse />} />
            <Route path="/part-one/strengths-evidence-map" element={<EvidenceMap activityKey="strengths-evidence-map" />} />
            <Route path="/part-one/energy-map" element={<EvidenceMap activityKey="energy-map" />} />
            <Route path="/part-one/values-in-action" element={<EvidenceMap activityKey="values-in-action" />} />
            <Route path="/part-one/:activityKey" element={<Activity />} />
            <Route path="/compass" element={<CareerCompass />} />
            <Route path="/part-two" element={<PartTwo />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </SparkProvider></SparkErrorBoundary>
  );
}

export default App;
